<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="title">Examinations</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-3">
          <el-select
            class="select-default"
            v-model="pagination_e.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination_e.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>

        <div class="col-sm-6">
          <el-tooltip v-if="g_project.status < 7" content="Validate examination sheet and start analysis" placement="top" effect="light">
            <p-button type="warning" size="md" class="btn btn-info btn-md" @click="handle_run_analyze($event)">
              Start Analyze
            </p-button>
          </el-tooltip>

          <el-tooltip v-if="g_project.status > 4" content="Merge selected high quality FASTA files into one and its CSV file for Gisaid" placement="top" effect="light">
            <p-button type="success" size="md" class="btn btn-info btn-md" @click="handle_collect_fasta($event)">
              Make Fasta and metadata
            </p-button>
          </el-tooltip>
        </div>

        <div class="col-sm-3">
          <div v-if="id_project" class="pull-right">
        <div class="category"><h3>Selected Project: {{ g_project.name }}</h3></div>
          </div>
        </div>

        <div class="col-sm-12 mt-2">
          <el-table class=""
                    ref="examinationsTable"
                    :data="examinations_data"
                    border
                    highlight-current-row
                    @current-change="handleCurrentChange_e"
                    @selection-change="handleSelectionChange"
                    row-key="id_examination"
                    style="width: 100%"
                    :row-class-name="tableRowClassName"
                    >

            <el-table-column v-for="column in tableColumns_e1"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              sortable
                              >
            </el-table-column>

            <el-table-column
              label="Status"
              min-width="140"
              align="center"
              prop="status"
              sortable
              >
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.status === 1" size="small" type="" effect="light"> NEW </el-tag>
                  <el-tag v-else-if="scope.row.status === 2" size="small" type="danger" effect="dark"> WRONG </el-tag>
                  <el-tag v-else-if="scope.row.status === 3" size="small" type="warning" effect="light"> SUBMITTED </el-tag>
                  <el-tag v-else-if="scope.row.status === 4" size="small" type="warning" effect="dark"> RUNNING </el-tag>
                  <el-tag v-else-if="scope.row.status === 6" size="small" type="success" effect="light"> WARNING </el-tag>
                  <el-tag v-else-if="scope.row.status === 7" size="small" type="success" effect="dark"> VALID </el-tag>
                  <el-tag v-else-if="scope.row.status === 9" size="small" type="" effect="dark"> LOCKED </el-tag>
                  <el-tag v-else-if="scope.row.status === 0" size="small" type="info" effect="dark"> NO DATA </el-tag>
                  <el-tag v-else size="small" type="default" effect="plain">  </el-tag>
              </template>
            </el-table-column>

            <el-table-column
                  type="selection"
                  width="55"
                  :selectable="canSelectRow"
                  :reserve-selection="true"
            >
            </el-table-column>

            <el-table-column v-for="column in tableColumns_e2"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              sortable
                              >
            </el-table-column>

            <el-table-column
              label="% 20X"
              min-width="80"
              align="center"
              >
              <template slot-scope="scope"> {{ (scope.row.pct_target_bases_20x * 100).toFixed(2) }}
              </template>
            </el-table-column>

            <el-table-column v-for="column in tableColumns_e3a"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              sortable
                              >
            </el-table-column>

            <el-table-column
              label="Next Status"
              min-width="120"
              align="center"
              prop="next_over_all_status"
              sortable
              >
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.next_over_all_status === 'good'" size="small" type="success" effect="dark"> GOOD </el-tag>
                  <el-tag v-else-if="scope.row.next_over_all_status === 'bad'" size="small" type="danger" effect="dark"> BAD </el-tag>
                  <el-tag v-else-if="scope.row.next_over_all_status === 'mediocre'" size="small" type="warning" effect="dark"> MEDIOCRE </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="Missing Data"
              min-width="130"
              align="center"
              prop="missing_data"
              sortable
              >
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.next_over_all_status === 'good'" size="small" type="success" effect="dark"> GOOD </el-tag>
                  <el-tag v-else-if="scope.row.next_over_all_status === 'bad'" size="small" type="danger" effect="dark"> BAD </el-tag>
                  <el-tag v-else-if="scope.row.next_over_all_status === 'mediocre'" size="small" type="warning" effect="dark"> MEDIOCRE </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="Mixed Sites"
              min-width="120"
              align="center"
              prop="mixed_sites"
              sortable
              >
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.mixed_sites === 'good'" size="small" type="success" effect="dark"> GOOD </el-tag>
                  <el-tag v-else-if="scope.row.mixed_sites === 'bad'" size="small" type="danger" effect="dark"> BAD </el-tag>
                  <el-tag v-else-if="scope.row.mixed_sites === 'mediocre'" size="small" type="warning" effect="dark"> MEDIOCRE </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="Private Mut"
              min-width="120"
              align="center"
              prop="private_mutation"
              sortable
              >
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.private_mutation === 'good'" size="small" type="success" effect="dark"> GOOD </el-tag>
                  <el-tag v-else-if="scope.row.private_mutation === 'bad'" size="small" type="danger" effect="dark"> BAD </el-tag>
                  <el-tag v-else-if="scope.row.private_mutation === 'mediocre'" size="small" type="warning" effect="dark"> MEDIOCRE </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="SNP Clusters"
              min-width="120"
              align="center"
              prop="snp_clusters"
              sortable
              >
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.snp_clusters === 'good'" size="small" type="success" effect="dark"> GOOD </el-tag>
                  <el-tag v-else-if="scope.row.snp_clusters === 'bad'" size="small" type="danger" effect="dark"> BAD </el-tag>
                  <el-tag v-else-if="scope.row.snp_clusters === 'mediocre'" size="small" type="warning" effect="dark"> MEDIOCRE </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="Frame shift"
              min-width="120"
              align="center"
              prop="frame_shift"
              sortable
              >
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.frame_shift === 'good'" size="small" type="success" effect="dark"> GOOD </el-tag>
                  <el-tag v-else-if="scope.row.frame_shift === 'bad'" size="small" type="danger" effect="dark"> BAD </el-tag>
                  <el-tag v-else-if="scope.row.frame_shift === 'mediocre'" size="small" type="warning" effect="dark"> MEDIOCRE </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="Stop codons"
              min-width="120"
              align="center"
              prop="stop_codons"
              sortable
              >
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.stop_codons === 'good'" size="small" type="success" effect="dark"> GOOD </el-tag>
                  <el-tag v-else-if="scope.row.stop_codons === 'bad'" size="small" type="danger" effect="dark"> BAD </el-tag>
                  <el-tag v-else-if="scope.row.stop_codons === 'mediocre'" size="small" type="warning" effect="dark"> MEDIOCRE </el-tag>
              </template>
            </el-table-column>

            <el-table-column v-for="column in tableColumns_e3b"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              sortable
                              >
            </el-table-column>

            <el-table-column
              :min-width="180"
              fixed="right"
              class-name="td-actions"
              label="Actions">
              <template slot-scope="props">
                <p-button v-if="props.row.status < 12" type="info" size="sm" icon  @click="handle_exam_detail(props.$index, props.row, $event)">
                  <i class="fas fa-edit"></i>
                </p-button>
                <p-button v-if="props.row.status > 0 && props.row.status < 3" type="warning" size="sm" icon @click="handle_exam_validate(props.$index, props.row, $event, type='BP')">
                  <i class="fas fa-cogs"></i>
                </p-button>
                <p-button v-if="(props.row.status === 0) || (props.row.status > 5)" type="light" size="sm" icon @click.prevent="handleModalQC( props.$index, props.row, $event, 'M')">
                  <i class="fas fa-chart-line"></i>
                </p-button>
                <p-button v-if="(props.row.status === 0) || (props.row.status > 5)" type="dark" size="sm" icon @click.prevent="handleShowQC( props.$index, props.row, $event, 'M')">
                  <i class="fas fa-chart-pie"></i>
                </p-button>
                <p-button v-if="(props.row.status > 0) && (props.row.status < 3)" type="danger" size="sm" icon @click="handle_exam_delete(props.$index, props.row, $event)">
                  <i class="fa fa-times"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{from_e + 1}} to {{to_e}} of {{total_e}} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination_e.currentPage"
                        :per-page="pagination_e.perPage"
                        :total="pagination_e.total">
          </p-pagination>
        </div>
      </div>

    </div>

    <div v-if="substs.length > 0" class="col-md-12 card">
      <div class="card-header">
        <div class="category"><h3>Variants Table for Sample: {{ g_examination_sample_id.sample_id }}</h3></div>
      </div>
      <div class="card-body row">
        <div class="col-sm-3">
        </div>

        <div class="col-sm-3">
          <div v-if="id_project" class="pull-right">
          </div>
        </div>

        <div class="col-sm-12 mt-2">
          <el-table class=""
                    ref="xsubs"
                    :data="substs"
                    border
                    highlight-current-row
                    style="width: 100%"
                    >
            <el-table-column v-for="column in tableColumns_s1"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              sortable
                              >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>


    <modal :show.sync="modal_exam_detail" headerClasses="justify-content-center" :show-close="true" @close="handle_close_modal">
      <h5 v-if="g_examination" slot="header" class="title title-up">{{ g_examination.sample_id }}</h5>
      <div class="row">
        <el-tabs class="col-md-12" type="border-card" @tab-click="">
          <el-tab-pane label="Examination">
            <div class="col-md-12">
              <h6 slot="" class="title text-center">Items with asterisk (*) are mandatory</h6>
              <form>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">Sample <b class="my_asterisk"> * </b></div>
                        <el-input type="text" placeholder="" size="small" v-model="exam_detail.sample_id"></el-input>

                        <div class="sub-title">Description</div>
                        <textarea type="textarea" class="form-control" rows="6" placeholder="" size="small" v-model="exam_detail.description"> </textarea>

                        <div class="sub-title">Zip CODE <b class="my_asterisk"> * </b></div>
                        <el-input type="text" placeholder="" size="small" v-model="exam_detail.zip_code"></el-input>

                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">COLLECTION DATE <b class="my_asterisk"> * </b></div>
                        <el-date-picker type="date"
                                  size="small"
                                  placeholder=""
                                  format="dd. MM. yyyy"
                                  label="Date"
                                  value-format="yyyy-MM-dd"
                                  v-model="exam_detail.collection_date">
                        </el-date-picker>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">ADDITIONAL LOCATION INFORMATION</div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="exam_detail.add_location">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">ADDITIONAL HOST INFORMATION</div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="exam_detail.add_host_info">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">GENDER <b class="my_asterisk"> * </b></div>
                        <el-select class="select-neutral"
                                  placeholder="Select Gender"
                                  size="small"
                                  v-model="exam_detail.gender">
                          <el-option v-for="option in gender"
                                    class="select-info"
                                    :value="option.id"
                                    :label="option.value"
                                    :key="option.id">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">PATIENT AGE <b class="my_asterisk"> * </b></div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="exam_detail.patient_age">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">PATIENT STATUS <b class="my_asterisk"> * </b></div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="exam_detail.patient_status">
                        </el-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-title">SPECIMEN SOURCE</div>
                        <el-select class="select-neutral"
                                  placeholder="Select Specimen"
                                  size="small"
                                  v-model="exam_detail.speciment_source">
                          <el-option v-for="option of specimen"
                                    class="select-info"
                                    :value="option"
                                    :label="option"
                                    :key="option">
                          </el-option>

                        </el-select>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">OUTBREAK</div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="exam_detail.outbreak">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">LAST VACCINATED</div>
                        <el-input type="text"
                                  size="small"
                                  placeholder=""
                                  v-model="exam_detail.last_vaccinated">
                        </el-input>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">TREATMENT</div>
                        <textarea type="textarea" class="form-control" rows="2" placeholder="" size="small" v-model="exam_detail.treatment"> </textarea>
                      </div>
                      <div class="col-md-12">
                        <div class="sub-title">COMMENT</div>
                        <textarea type="textarea" class="form-control" rows="2" placeholder="" size="small" v-model="exam_detail.comment"> </textarea>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4 mr-auto ml-auto">
                    <p-button type="info" block @click.native="submit_exam_detail()">Submit</p-button>
                  </div>
                </div>
              </form>
            </div>
          </el-tab-pane>

        </el-tabs>

      </div>

    </modal>

    <modal :show.sync="modal_exam_qc" headerClasses="justify-content-center" :show-close="true">
      <h3 slot="header" class="title title-up"> MAPPING STATISTICS </h3>
      <exam_qc exam_id = ""></exam_qc>
    </modal>

  </div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';
  import {Table, TableColumn, Select, Option, Tabs, TabPane, Tag, } from 'element-ui';
  import Button from 'src/components/UIComponents/Button';
  import PPagination from 'src/components/UIComponents/Pagination.vue';
  import Loading from 'src/components/Layout/LoadingMainPanel.vue';
  import Modal from 'src/components/UIComponents/Modal'
  import Vars from 'src/components/Views/Vars.vue';
  import ExamQC from 'src/components/Views/ExamQC.vue'

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';
  import VueUploadComponent from 'vue-upload-component';
  Vue.component('file-upload', VueUploadComponent);

  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Tabs);
  Vue.use(Select);
  Vue.use(Option);


  export default {
    name: 'exams',
    props: {
    },
    components: {
      PPagination,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [Vars.name]: Vars,
      [Tag.name]: Tag,
      Modal,
      [ExamQC.name]: ExamQC,
    },
    computed: {
      ...mapState({
        token: state => state.token,
        projects: state => state.projects,
        id_project: state => state.id_project,
        id_project_detail: state => state.id_project_detail,
        examinations: state => state.examinations,
        id_examination: state => state.id_examination,
        substs: state => state.substs,
        user: state => state.user,
        exam_detail: state => state.exam_detail,

      }),

      ...mapGetters({
        g_project: 'g_project',
        g_examination: 'g_examination',
        g_examination_vars: 'g_examination_vars',
        g_examination_for_submit: 'g_examination_for_submit',
        g_examination_sample_id: 'g_examination_sample_id',

      }),

      pagedData_e () {
        return this.examinations.slice(this.from_e, this.to_e)
      },

      examinations_data () {
        if (!this.searchQuery_e) {
          this.pagination_e.total = this.examinations.length
          return this.pagedData_e
        }
        let result = this.examinations
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_e) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_e)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_e.total = result.length
        return result.slice(this.from_e, this.to_e)
      },

      to_e () {
        let highBound = this.from_e + this.pagination_e.perPage
        if (this.total_e < highBound) {
          highBound = this.total_e
        }
        return highBound
      },

      from_e () {
        return this.pagination_e.perPage * (this.pagination_e.currentPage - 1)
      },

      total_e () {
        this.pagination_e.total = this.examinations.length
        return this.examinations.length
      },

      modal_exam_detail: {
        get () {
          return this.$store.state.modal_exam_detail;
        },
        set (value) {
          this.$store.commit('m_modal_exam_detail', value);
        }
      },

      modal_exam_qc: {
        get () {
          return this.$store.state.modal_exam_qc;
        },
        set (value) {
          this.$store.commit('m_modal_exam_qc', value);
        }
      },

    },


    data () {
      return {
        progress_bar_colors: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 40},
          {color: '#5cb87a', percentage: 60},
          {color: '#1989fa', percentage: 80},
          {color: '#6f7ad3', percentage: 100}
        ],
        specimen: [
          "Sputum",
          "Alveolar lavage fluid",
          "Oro-pharyngeal swab",
          "Blood",
          "Tracheal swab",
          "Urine",
          "Stool",
          "Cloakal swab",
          "Organ",
          "Feces",
          "Other",
        ],
        gender: [
          {"id": 1, "value": "Female"},
          {"id": 2, "value": "Male"},
          {"id": 0, "value": "Unknown"},
        ],

        files: [],
        formdata_exam: {
          sample_id: "",
          description: "",
        },

        formdata_report: {
          description: "",
        },

        pagination_e: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50, 100, 150, 200, 500, 1000],
          total: 0
        },

        tableColumns_e1: [
          {
            prop: 'id_examination',
            label: 'ID',
            minWidth: 60,
            align: "right"
          },
          {
            prop: 'sample_id',
            label: 'SampleID',
            minWidth: 150,
            align: "right"
          },

        ],

        tableColumns_e2: [
          {
            prop: 'total_reads',
            label: 'Total reads',
            minWidth: 120
          },
        ],

        tableColumns_e3a: [
          {
            prop: 'pan_lineage',
            label: 'Lineage',
            minWidth: 100
          },
          {
            prop: 'next_clade',
            label: 'Next Clade',
            minWidth: 120
          },
          {
            prop: 'next_total_mutations',
            label: 'Total Var',
            minWidth: 100
          },
        ],

        tableColumns_e3b: [
          {
            prop: 'next_total_insertions',
            label: 'Insertions',
            minWidth: 110
          },
          {
            prop: 'next_total_gaps',
            label: 'Gaps',
            minWidth: 90
          },
          {
            prop: 'next_total_missing',
            label: 'Missing',
            minWidth: 100
          },
          {
            prop: 'next_total_non',
            label: 'Non ACGTN',
            minWidth: 120
          },
        ],

        project_name: "",
        exam_selections: [],

        tableColumns_s1: [
          {
            prop: 'next_aasub_gene',
            label: 'Gene',
            minWidth: 50,
            align: "right"
          },
          {
            prop: 'sub_name',
            label: 'Sub name',
            minWidth: 70,
            align: "right"
          },
          {
            prop: 'aasub_name',
            label: 'Sub name amino',
            minWidth: 70,
            align: "right"
          },
          {
            prop: 'next_sub_pos',
            label: 'Pos',
            minWidth: 50,
            align: "right"
          },
          {
            prop: 'next_sub_ref',
            label: 'Ref',
            minWidth: 50,
            align: "right"
          },
          {
            prop: 'next_sub_query',
            label: 'Sub',
            minWidth: 50,
            align: "right"
          },
          {
            prop: 'next_aasub_codon',
            label: 'Pos amino',
            minWidth: 50,
            align: "right"
          },
          {
            prop: 'next_aasub_ref',
            label: 'Ref amino',
            minWidth: 50,
            align: "right"
          },
          {
            prop: 'next_aasub_query',
            label: 'Sub amino',
            minWidth: 50,
            align: "right"
          },
          {
            prop: 'next_aasub_ref_codon',
            label: 'Codon ref',
            minWidth: 60,
            align: "right"
          },
          {
            prop: 'next_aasub_query_codon',
            label: 'Codon sub',
            minWidth: 60,
            align: "right"
          },

        ],


      }
    },

    methods: {
      ...mapMutations({
        m_id_examination: 'm_id_examination',
        m_modal_transcripts: 'm_modal_transcripts',
        m_modal_exam_detail: 'm_modal_exam_detail',
        m_id_examination_detail: 'm_id_examination_detail',
        m_modal_exam_qc: 'm_modal_exam_qc',
        m_qc_a: 'm_qc_a',
        m_qc_c: 'm_qc_c',
        m_collection: 'm_collection',
        m_chart_bar_a: 'm_chart_bar_a',
        m_exam_detail: 'm_exam_detail',

      }),

      ...mapActions({
        a_examinations: 'a_examinations',
        a_projects: 'a_projects',
        a_vars: 'a_vars',
        a_show_qc: 'a_show_qc',
        a_examination_validate: 'a_examination_validate',
        a_examination_delete: 'a_examination_delete',
        a_substs: 'a_substs',
        a_exam_detail: 'a_exam_detail',
        a_merge_fasta: 'a_merge_fasta',
        a_notify: 'a_notify',

        }),

      tableRowClassName({row, rowIndex}) {
        if (row.status > 18) {
          return 'row_light_gray';
        } else if (row.status > 11) {
          return 'row_light_gray';
        } else if (row.status > 9) {
          return 'row_light_gray';
        } else if (row.status > 8) {
          return 'row_light_gray';
        } else if (row.status > 1) {
          return 'row_light_gray';
        } else if (row.status > 0) {
          return 'row_light_gray';
        } else {
          return 'row_light_gray';
        }
      },

      canSelectRow(row, index) {
        return row.status >= 6;
      },

      handle_exam_detail (index, row, event) {
        event.stopImmediatePropagation();
        this.m_id_examination_detail(row.id_examination);
        this.m_exam_detail(row.id_examination);
        this.m_modal_exam_detail(true);
      },

      handle_exam_validate (index, row, event, type) {
        event.stopImmediatePropagation();
        this.a_examination_validate( {"id_examination": row.id_examination, "act": type} );

        // if (row.status === 10) {
        //   row.status = 11;
        //   this.a_examination( {"cufi": this.cufi, "id_examination": this.id_examination} );
        // } else if (row.status > 10 && row.status < 20) {
        //   row.status = 21;
        //   this.a_examination( {"cufi": this.cufi, "id_examination": this.id_examination} );
        // } else if (row.status > 10 && row.status < 20) {
        //   row.status = 21;
        //   this.a_examination( {"cufi": this.cufi, "id_examination": this.id_examination} );
        // } else {
        //   row.status = 9;
        // }
        // this.m_id_examination_lock(row.id_examination);
        // this.m_modal_project_detail(true);
      },

      handle_exam_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_examination_delete( {'id_examination': row.id_examination} );
      },

      handleModalQC (index, row, event) {
        event.stopImmediatePropagation();
        axios.get(process.env.VUE_APP_BE + '/examination_qc', { withCredentials: true, params: { "id_examination": row.id_examination  }, headers: { 'Authorization': this.token, 'Content-Type': 'application/json;charset=UTF-8', }, })
            .then(response => {
                this.m_qc_a(response.data["qc_a"]);
                this.m_qc_c(response.data["qc_c"]);
                this.m_chart_bar_a(response.data["chart_bar_a"]);
                this.m_modal_exam_qc(true);
            }, error => {
                console.log(error);
            });

      },

      handleShowQC (index, row, event) {
        event.stopImmediatePropagation();
        // console.log(event);
        // this.m_id_project_detail(row.id_project);
        axios.get(process.env.VUE_APP_BE + '/showqc', { withCredentials: true, params: { id_project: row.id_project, id_examination: row.id_examination, filename: "multiqc_report.html" }, headers: { 'Authorization': this.token, 'Content-Type': 'text/html', }, responseType: 'text', })
            .then(response => {
              var myWindow = window.open("", "_blank");
              myWindow.document.write(response.data);
              myWindow.document.close();
            }, error => {
                console.log(error);
            });
      },

      handle_exam_reload (event) {
        event.stopImmediatePropagation();
        this.a_examinations( {"id_project": this.id_project} );
      },

      handle_collect_fasta (event) {
        // event.stopImmediatePropagation();
        // this.a_notify( "We're creating your FASTA FILE just now." );
        let big_fasta = [];
        for (let one of this.exam_selections) {
          big_fasta.push(one.id_examination);
        }
        this.a_merge_fasta({"id_project": this.id_project, "examinations": big_fasta} );

      },

      handle_run_analyze (event) {
        event.stopImmediatePropagation();
        for (let one of this.g_examination_for_submit) {
          this.a_examination_validate( {"id_examination": one.id_examination, "act": "BP"} );
        }
      },

      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`);
      },

      handle_close_modal () {

      },

      fetchEventsList () {
        if (this.id_project > 0) {
          this.a_examinations( {"id_project": this.id_project} );
        }
      },

      cancelAutoUpdate () {
        clearInterval(this.timer)
      },

      handleCurrentChange_e(val) {
        event.stopImmediatePropagation();
        this.m_id_examination(val.id_examination);
        this.a_substs(val.id_examination);

        // if (val && val.id_examination > 0 && val.status > 8) {
        //   this.m_id_examination(val.id_examination);
        //   this.m_id_examination_detail(val.id_examination);
        //   // this.a_vars( {"cufi": this.cufi, "id_examination": this.id_examination} );
        // } else if (val && val.id_examination > 0) {
        //   this.m_id_examination(0);
        //   this.m_id_examination_detail(0);
        // } else {
        //   this.m_id_examination(0);
        //   this.m_id_examination_detail(0);
        // }
      },

      handleSelectionChange(val) {
        // event.stopImmediatePropagation();
        this.exam_selections = val;
      },

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.examinationsTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.examinationsTable.clearSelection();
        }
      },

      submit_exam_detail(){
        this.a_exam_detail(this.exam_detail)
        this.m_modal_exam_detail(false);

        // this.a_notify( { "message": "HELLO!" } );

      },

      submit_exam() {
        // this.a_change_interpretation( this.formdata_change_class );
        // this.a_vars( {"order": this.vars_order, "er_switch": this.er_switch, "cufi": this.cufi, "id_examination": this.id_examination} );
        // this.a_notify("Interpretation was changed.");
      },


      watch_id_project () {
        this.$refs.examinationsTable.clearSelection();
      },

    },

    beforeMount () {
      // this.m_id_project(0);
    },

    created () {
        // this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 60000)

    },

    mounted () {
      this.examinations.forEach(row => {
        if (row.status === 7) {
          this.$refs.examinationsTable.toggleRowSelection(row);
        }
      });

    },

    beforeDestroy () {
      clearInterval(this.timer)
    },

    afterDestroy () {
      this.m_id_examination(0);
    },

    watch: {
      id_project: {
        handler: 'watch_id_project',
        immediate: true
      },
    },



  }
</script>
<style scoped lang="scss">
.el-table .td-actions{
  button.btn {
    margin-right: 2px;
  }
}

.el-table {
  font-size: 12px !important;
}

.el-table .cell{
  line-height: 20px !important;
}

.el-table td, .el-table th {
  padding: 3px 0 !important;
}

.el-table .row_0 {
  background: rgb(253, 253, 253) !important;
}

.el-table .row_1 {
  background: rgb(243, 245, 152) !important;
}

.el-table .row_2 {
  background: rgb(248, 221, 171) !important;
}

.el-table .row_9 {
  background: rgb(252, 192, 82) !important;
}

.el-table .row_10 {
  background: rgb(120, 244, 248) !important;
}

.el-table .row_12 {
  background: rgb(154, 240, 168) !important;
}

.el-table .row_19 {
  background: rgb(5, 153, 29) !important;
}

.el-table .row_light_gray {
  background: rgb(255, 255, 255) !important;
}


.el-table .warning-row {
  background: rgb(241, 175, 52) !important;
}

.el-table .success-row {
  background: #06d410 !important;
}

.el-table .info-row {
  background: #8fbdf1 !important;
}

h4 {
  margin-top: 5px !important;
}

.dolu {
  padding-top: 80px !important;
}

.table > thead > tr > th, .el-table table > thead > tr > th {
  font-size: 12px !important;
}

.mezera {
  margin-right: 10px;
}

.my_asterisk {
  font-size: 14px !important;

}

</style>
